import api from './api'

export const dashboardService = {

    async getDashboardData() {
        try {
            const response = await api.post('dashboard/get-dashboard-data')
            return response
        } catch (e) {
            console.log('e', e)
        }
    },
    
}
